import { ProjectMethodologyEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { useSendGpnAnalyticsEvent } from 'hooks/useSendGpnAnalyticsEvent';
import { CreatingTypes } from 'pages/Project/Common/Contract/OtherCreate/commonData';
import { Button, ContextMenu } from 'uikit';

import type { CSSProperties } from 'react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

export const AddOtherBtn = ({
    isDisabled,
    onCreateClick,
    methodology,
    hasWorkOrders,
    style,
}: {
    isDisabled: boolean;
    onCreateClick: (creatingType?: CreatingTypes) => void;
    methodology: ProjectMethodologyEnum;
    hasWorkOrders?: boolean;
    style?: CSSProperties;
}) => {
    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId, false);
    const { sendGpnAnalyticsEvent } = useSendGpnAnalyticsEvent();

    const ref = useRef(null);
    const [isContextMenuOpen, setIsContextMenuOpen] = useState<boolean>(false);

    const handleContextToggle = useCallback(() => {
        setIsContextMenuOpen((prev) => !prev);
    }, []);

    const actions = useMemo(
        () => [
            {
                label: 'Вручную',
                action: () => {
                    onCreateClick(CreatingTypes.MANUAL);
                    handleContextToggle();
                },
            },
            {
                label: 'Из справочника методик расчета',
                action: () => {
                    onCreateClick(CreatingTypes.BOOK);
                    handleContextToggle();
                },
            },
        ],
        [handleContextToggle, onCreateClick],
    );

    const createBtnHandler = useCallback(() => {
        if (hasWorkOrders) {
            handleContextToggle();
        } else {
            onCreateClick();
        }

        sendGpnAnalyticsEvent({
            componentId: 'rim_create other create button_pressed',
            projectId,
            projectName: projectData?.name,
            projectType: projectData?.contractType,
            projectDO: projectData?.subsidiary?.name,
            methodology: projectData?.methodology,
        });
    }, [
        handleContextToggle,
        hasWorkOrders,
        onCreateClick,
        projectData?.contractType,
        projectData?.methodology,
        projectData?.name,
        projectData?.subsidiary?.name,
        projectId,
        sendGpnAnalyticsEvent,
    ]);

    if (methodology === ProjectMethodologyEnum.Bim) {
        return (
            <Button
                style={style}
                label="Создать прочие"
                view="secondary"
                size="s"
                disabled={isDisabled}
                onClick={createBtnHandler}
            />
        );
    }

    return (
        <>
            <Button
                ref={ref}
                style={style}
                label="Создать прочие"
                view="secondary"
                size="s"
                disabled={isDisabled}
                onClick={createBtnHandler}
            />
            {hasWorkOrders && (
                <ContextMenu
                    isOpen={isContextMenuOpen}
                    anchorRef={ref}
                    getItemLabel={({ label }) => label}
                    items={actions}
                    onClickOutside={handleContextToggle}
                    direction="downStartLeft"
                    getItemOnClick={({ action }) => action}
                    style={{
                        width: 154,
                    }}
                />
            )}
        </>
    );
};

AddOtherBtn.displayName = 'AddOtherBtn';
